module.exports = __webpack_public_path__ + "img/EgyptTechSiegeTower3_ua.0bdd1f99.webp";